import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      login(data.access_token, data.user);
      if (data.user.role === "admin") {
        navigate("/admin");
      } else if (data.user.status === "verified") {
        navigate("/dashboard");
      } else {
        navigate("/konto-pruefung");
      }
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Anmelden" testid="login-page">
      <form onSubmit={submit} className="space-y-6">
        {error && (
          <p className="text-sm text-destructive bg-destructive/5 border border-destructive/20 rounded-sm px-4 py-3" data-testid="login-error">
            {error}
          </p>
        )}
        <div className="space-y-2">
          <Label htmlFor="email">E-Mail</Label>
          <Input
            id="email"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="login-email-input"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Passwort</Label>
          <Input
            id="password"
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="login-password-input"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          className="w-full bg-gold hover:bg-golddark text-white rounded-sm py-6 transition-colors duration-500"
          data-testid="login-submit-button"
        >
          {loading ? "Anmelden…" : "Anmelden"}
        </Button>
      </form>
      <div className="mt-6 flex flex-col items-center gap-3 text-sm">
        <Link to="/passwort-vergessen" className="text-gold hover:text-golddark transition-colors duration-500" data-testid="forgot-password-link">
          Passwort vergessen?
        </Link>
        <span className="text-charcoal/50">
          Noch kein Konto?{" "}
          <Link to="/registrieren" className="text-gold hover:text-golddark transition-colors duration-500" data-testid="to-register-link">
            Registrieren
          </Link>
        </span>
      </div>
    </AuthLayout>
  );
}
